import React from 'react';

import PropTypes from 'prop-types';

import styled from 'styled-components';

import { Icon } from 'apps/auth/components/common/Icon/Icon';
import NewInputWrapper from 'apps/auth/components/form-multi/NewInputWrapper';
import { usePageMessages } from 'apps/auth/hooks/selectors';
import media from 'apps/auth/theme/media';

export const SearchIconWrap = styled.div`
    margin-right: 16px;

    ${media.desktop1920} {
        margin-right: 24px;
    }
`;

const Filter = (props) => {
    const { searchPlaceholder } = usePageMessages();

    return (
        <NewInputWrapper
            name="search"
            leftInputComponent={
                <SearchIconWrap>
                    <Icon name="search" color="secondary" />
                </SearchIconWrap>
            }
        >
            <input type="search" placeholder={searchPlaceholder} value={props.value} onChange={props.onChange} />
        </NewInputWrapper>
    );
};

Filter.propTypes = {
    value: PropTypes.string,
    onChange: PropTypes.func,
};

export default Filter;
